import { Component, OnInit, Input } from '@angular/core';
import { TermsConditionsService } from "./terms-conditions.service";
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
  @Input() optionSelect: string;

  listTermsConditions: any;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  constructor(private termsConditionsService: TermsConditionsService, public LANG: CommonUtilitiesService) {

  }
  /**
   * Description: Método que llama el servicio web que obtiene los términos y condiciones
   * Autor: Steven Sterling
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
    this.termsConditionsService.getTermsCondList({ "category": this.optionSelect }).subscribe((dataInfo => {
      if (dataInfo['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
        this.listTermsConditions = dataInfo['obj'].map(obj => {
          let newObj: any = new Object();
          newObj.description = obj.documentLink;
          newObj.title = obj.title;
          return newObj;
        });
      } else {
        this.modalTitle = "Error: ";
        this.modalContent = "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      }
    }),
      (err) => {
        this.modalTitle = "Error: " + err.code;
        this.modalContent = "No se ha podido establecer la conexión con el servidor.";
        this.isShowModal = true;
      });
  }

  openPdf(file) {
    window.open(file);
  }
}
